import api from '../api';

export const tagsApi = api.injectEndpoints({
  endpoints: builder => ({
    createTag: builder.mutation({
      query: payload => ({
        url: '/api/lookup/create/tag',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['GetAllTags']
    }),
    fetchTags: builder.query({
      query: () => ({
        url: '/api/lookup/fetch/tags',
        method: 'GET'
      }),
      providesTags: ['GetAllTags']
    }),
    fetchTagById: builder.query({
      query: tagId => ({
        url: '/api/lookup/fetch/students/bytag',
        method: 'GET',
        params: { tagId }
      })
    })
  })
});

export const {
  useCreateTagMutation,
  useFetchTagsQuery,
  useFetchTagByIdQuery,
  useLazyFetchTagByIdQuery
} = tagsApi;
